app.directive('dropdownKeyboardNavigation', ['$filter', '$timeout', function($filter, $timeout){
    return {
        restrict: 'A',
        link: function(scope, element, attrs, ngModel){
            console.log('linked', element);
            element.parent().bind('keypress', function (e) {
                children = element.children();
                children.removeClass("active");
                for (var i = 0; i < children.length; i++) {
                    var letter = String.fromCharCode(e.which);
                    var charat = children[i].textContent.replace(/\s+/, '').charAt(0);
                    console.log(charat, letter);
                    if (charat === letter) {
                        children[i].className += " active";
                        element[0].scrollTop = children[i].offsetTop;
                    }
                }
            });
        }
    }
}]);
